import { render, staticRenderFns } from "./MicrophonePermissionModal.vue?vue&type=template&id=1c53b117&"
import script from "./MicrophonePermissionModal.vue?vue&type=script&lang=js&"
export * from "./MicrophonePermissionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports